import { render, staticRenderFns } from "./ReceiptPage.vue?vue&type=template&id=c7e50a66&scoped=true&"
import script from "./ReceiptPage.vue?vue&type=script&lang=js&"
export * from "./ReceiptPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptPage.vue?vue&type=style&index=0&id=c7e50a66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e50a66",
  null
  
)

export default component.exports